// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__ai7vr","rowCenter":"layout_rowCenter__317CT","noMargin":"layout_noMargin__3G8cb","box_style":"layout_box_style__3rmQx"};